"use client";

import { ColorPicker } from "@/components/admin/content/ColorPicker";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@/components/ui/popover";
import {
    Select,
    SelectTrigger,
    SelectValue,
    SelectContent,
    SelectItem,
} from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { IBlocks } from "@/types";
import React from "react";
interface Props {
    block: IBlocks;
    update: (value: IBlocks) => void;
}
export default function SocialButtonsCustomization({ block, update }: Props) {
    const onChangeBackgroundColor = (value: string) => {
        update({
            ...block,
            colour: {
                ...block.colour,
                background: value,
            },
        });
    };
    const onChangeBackgroundBlock = (value: string) => {
        update({
            ...block,
            colour: {
                ...block.colour,
                background_block: value,
            },
        });
    };
    const onChangeTextColor = (value: string) => {
        update({
            ...block,
            colour: {
                ...block.colour,
                text: value,
            },
        });
    };
    const onChangePosition = (value: string) => {
        update({
            ...block,
            colour: {
                ...block.colour,
                position: value,
            },
        });
    };

    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <Label variant="toggle">Custom theme</Label>
                <Switch
                    onCheckedChange={(checked) =>
                        update({
                            ...block,
                            colour: {
                                ...block.colour,
                                toggle: checked,
                            },
                        })
                    }
                    checked={block.colour.toggle}
                />
            </div>
            {block.colour.toggle && (
                <>
                    <div className="flex items-center justify-between gap-4">
                        <div className="">
                            <Label>Block background</Label>
                        </div>
                        <Popover>
                            <PopoverTrigger asChild>
                                <Button
                                    className="h-9 w-9 rounded-full border-2 border-primary"
                                    style={{
                                        background:
                                            block.colour?.background_block,
                                    }}
                                ></Button>
                            </PopoverTrigger>
                            <PopoverContent className="z-[999]">
                                <ColorPicker
                                    gradient
                                    value={
                                        block.colour?.background_block ||
                                        "transparent"
                                    }
                                    onChange={onChangeBackgroundBlock}
                                />
                            </PopoverContent>
                        </Popover>
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <div className="">
                            <Label>Icon Background</Label>
                        </div>
                        <Popover>
                            <PopoverTrigger asChild>
                                <Button
                                    className="h-9 w-9 rounded-full border-2 border-primary"
                                    style={{
                                        background: block.colour.background,
                                    }}
                                ></Button>
                            </PopoverTrigger>
                            <PopoverContent className="z-[999]">
                                <ColorPicker
                                    gradient
                                    value={block.colour.background}
                                    onChange={onChangeBackgroundColor}
                                />
                            </PopoverContent>
                        </Popover>
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <div className="">
                            <Label>Text color</Label>
                        </div>
                        <Popover>
                            <PopoverTrigger asChild>
                                <Button
                                    className="h-9 w-9 rounded-full border-2 border-primary"
                                    style={{ background: block.colour.text }}
                                ></Button>
                            </PopoverTrigger>
                            <PopoverContent className="z-[999]">
                                <ColorPicker
                                    value={block.colour.text}
                                    onChange={onChangeTextColor}
                                />
                            </PopoverContent>
                        </Popover>
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <div className="w-full">
                            <Label>Position</Label>
                        </div>
                        <Select
                            value={block.colour.position}
                            onValueChange={onChangePosition}
                        >
                            <SelectTrigger className="w-full">
                                <SelectValue placeholder="Position" />
                            </SelectTrigger>
                            <SelectContent className="z-[999]">
                                <SelectItem value="left">Left</SelectItem>
                                <SelectItem value="center">Center</SelectItem>
                                <SelectItem value="right">Right</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                </>
            )}
        </div>
    );
}
